import { render } from "./challenges.vue?vue&type=template&id=a456be4e&scoped=true"
import script from "./challenges.vue?vue&type=script&lang=js"
export * from "./challenges.vue?vue&type=script&lang=js"

import "./challenges.vue?vue&type=style&index=0&id=a456be4e&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\colin\\Documents\\WebProjects\\cee\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a456be4e"]])

export default __exports__